import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useCompanyRole } from '../domains/auth/companyRole';
import { RoleLoadingState } from './RoleStateScreen';

export function SuperAdminGuard({ children }: { children: ReactNode }) {
  const { user, loading, isPlatformUser, defaultRoute } = useCompanyRole();

  if (!user) return <Navigate to="/login" replace />;
  if (loading) return <RoleLoadingState label="Проверяем права платформы..." />;
  if (!isPlatformUser) return <Navigate to={defaultRoute} replace />;

  return <>{children}</>;
}
